import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e92532e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "taskModalContainer" }
const _hoisted_2 = { class: "taskModalContainer__element title formGroup--row" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " draw ", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " visibility_off ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " visibility ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "taskModalContainer__element title formGroup--row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "taskModalContainer__element" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sub Tareas:", -1))
const _hoisted_17 = { class: "taskModalContainer__element" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Visibilidad:", -1))
const _hoisted_19 = { class: "taskModalContainer__element" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Estado:", -1))
const _hoisted_21 = { class: "formGroup--row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Estado: ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un estado", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Por hacer", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0.5" }, "En Progreso", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Hecho", -1))
const _hoisted_27 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "taskModalContainer__element" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fecha de creación:", -1))
const _hoisted_30 = { class: "taskModalContainer__element" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fecha de entrega:", -1))
const _hoisted_32 = { class: "formGroup--date" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Fecha de Entrega")
], -1))
const _hoisted_34 = ["disabled", "value"]
const _hoisted_35 = { class: "taskModalContainer__element" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_task ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Guardar", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Cancelar", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_43 = { class: "taskModalContainer__element title formGroup--row" }
const _hoisted_44 = { class: "formGroup--row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "userPick" }, "Agregar Usuario a Tarea", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un usuario", -1))
const _hoisted_47 = ["value"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "formGroup--row--addUserButton"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " person_add ")
], -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "usersContainer" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "taskModalContainer__element" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Adjuntos")
], -1))
const _hoisted_52 = { class: "taskModalContainer__attachmentGroup" }
const _hoisted_53 = { class: "taskModalContainer__attachmentsForm" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "taskModalContainer__attachmentsForm__row" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Nuevo archivo adjunto")
  ])
], -1))
const _hoisted_55 = { class: "taskModalContainer__attachmentsForm__row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre:", -1))
const _hoisted_57 = { class: "taskModalContainer__attachmentsForm__row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "file" }, "Archivo:", -1))
const _hoisted_59 = { class: "taskModalContainer__attachmentsForm__row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "add", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "cancel", -1))
const _hoisted_62 = { class: "taskModalContainer__attachments" }
const _hoisted_63 = ["href"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "delete", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "taskModalContainer__element" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Comentarios")
], -1))
const _hoisted_68 = { class: "taskModalContainer__element taskModalContainer__createComments" }
const _hoisted_69 = { class: "taskModalContainer__createComments__buttons" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "add", -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "cancel", -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "taskModalContainer__element" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Actividad")
], -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "taskModalContainer__element" }, "No hay actividad registrada", -1))
const _hoisted_76 = [
  _hoisted_75
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCharging = _resolveComponent("ModalCharging")!
  const _component_UserProfilePicker = _resolveComponent("UserProfilePicker")!
  const _component_CommentItem = _resolveComponent("CommentItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalCharging, { open: _ctx.isLoading }, null, 8, ["open"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_ctx.task ? _ctx.task.name : 'Name'), 1),
      (_ctx.isUserAdmin || _ctx.isUserProducer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "taskModalContainer__element__button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.activeEditSession && _ctx.activeEditSession(...args)))
            }, _hoisted_5),
            _createElementVNode("button", {
              class: "taskModalContainer__element__button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteTask && _ctx.deleteTask(...args)))
            }, _hoisted_7),
            (!_ctx.isTaskPublic)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "taskModalContainer__element__button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.makeTaskPublic && _ctx.makeTaskPublic(...args)))
                }, _hoisted_9))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "taskModalContainer__element__button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.makeTaskPrivate && _ctx.makeTaskPrivate(...args)))
                }, _hoisted_11))
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.taskData.name) = $event))
      }, null, 512), [
        [_vModelText, _ctx.taskData.name]
      ]),
      _createElementVNode("button", {
        class: "taskModalContainer__element__button",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelEditSession && _ctx.cancelEditSession(...args)))
      }, _hoisted_14)
    ], 512), [
      [_vShow, _ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_15, [
      _hoisted_16,
      _createTextVNode(" " + _toDisplayString(this.subTasksNumber), 1)
    ], 512), [
      [_vShow, this.subTasksNumber > 0]
    ]),
    _createElementVNode("span", _hoisted_17, [
      _hoisted_18,
      _createTextVNode(" " + _toDisplayString(this.isTaskPublic ? 'Publica' : 'Privada'), 1)
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_19, [
      _hoisted_20,
      _createTextVNode(" " + _toDisplayString(' ' + _ctx.getStateName(_ctx.task ? _ctx.task.state : '')), 1)
    ], 512), [
      [_vShow, !_ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _withDirectives(_createElementVNode("select", {
        id: "status",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.taskData.state) = $event)),
        placeholder: "Elige un estado"
      }, _hoisted_27, 512), [
        [_vModelSelect, _ctx.taskData.state]
      ])
    ], 512), [
      [_vShow, _ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_28, [
      _hoisted_29,
      _createTextVNode(" " + _toDisplayString(!!_ctx.task.creationDate && _ctx.task.creationDate !== ''
        ? _ctx.formatDate(_ctx.task.creationDate) : 'No establecida'), 1)
    ], 512), [
      [_vShow, !_ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_30, [
      _hoisted_31,
      _createTextVNode(" " + _toDisplayString(!!_ctx.task.deliverDate && _ctx.task.deliverDate !== '' ? _ctx.task.deliverDate : 'No establecida'), 1)
    ], 512), [
      [_vShow, !_ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _withDirectives(_createElementVNode("input", {
        type: "date",
        id: "startDate",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.taskData.date) = $event))
      }, null, 512), [
        [_vModelText, _ctx.taskData.date]
      ])
    ], 512), [
      [_vShow, _ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("textarea", {
      class: "taskModalContainer__element",
      name: "",
      id: "",
      cols: "30",
      rows: "10",
      placeholder: "Descripción de la tarea",
      disabled: !_ctx.editSession,
      value: _ctx.task ? _ctx.task.description : ''
    }, null, 8, _hoisted_34), [
      [_vShow, !_ctx.editSession]
    ]),
    _withDirectives(_createElementVNode("textarea", {
      class: "taskModalContainer__element",
      name: "",
      id: "",
      cols: "30",
      rows: "10",
      placeholder: "Descripción de la tarea",
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.taskData.description) = $event))
    }, null, 512), [
      [_vShow, _ctx.editSession],
      [_vModelText, _ctx.taskData.description]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_35, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "taskModalContainer__element__buttonEdition taskModalContainer__element__buttonEdition--saveButton",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateTask && _ctx.updateTask(...args)))
          }, _hoisted_38)
        ]),
        _: 1
      }),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "taskModalContainer__element__buttonEdition taskModalContainer__element__buttonEdition--cancelButton",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelEditSession && _ctx.cancelEditSession(...args)))
          }, _hoisted_41)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.editSession]
    ]),
    _hoisted_42,
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _withDirectives(_createElementVNode("select", {
            id: "userPick",
            placeholder: "Elige un usuario",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pickedUserToAdd) = $event))
          }, [
            _hoisted_46,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersOnProject, (user) => {
              return (_openBlock(), _createElementBlock("option", {
                value: user.id,
                key: user.id
              }, _toDisplayString(user.name), 9, _hoisted_47))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.pickedUserToAdd]
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addUserToTask && _ctx.addUserToTask(...args)))
        }, _hoisted_49)
      ]),
      _createElementVNode("div", _hoisted_50, [
        _withDirectives(_createElementVNode("div", null, "No hay usuarios que vean esta tarea.", 512), [
          [_vShow, _ctx.usersOnTask.length < 1]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersOnTask, (user) => {
          return (_openBlock(), _createElementBlock("div", {
            key: user.id
          }, [
            _createVNode(_component_UserProfilePicker, {
              user: user,
              editing: true,
              onRemoveUserFrom: ($event: any) => (_ctx.removeUserFromTask(user.viewTaskId))
            }, null, 8, ["user", "onRemoveUserFrom"])
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, !_ctx.isTaskPublic]
    ]),
    _hoisted_51,
    _createElementVNode("div", _hoisted_52, [
      _withDirectives(_createElementVNode("div", _hoisted_53, [
        _hoisted_54,
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "name",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newDocumentData.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.newDocumentData.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("input", {
            type: "file",
            id: "file",
            onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.prepareFile && _ctx.prepareFile(...args)))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("button", {
            class: "taskModalContainer__attachmentsForm__buttons taskModalContainer__attachmentsForm__buttons--add",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.createDocument && _ctx.createDocument(...args)))
          }, [
            _hoisted_60,
            _createTextVNode(" Guardar ")
          ]),
          _createElementVNode("button", {
            class: "taskModalContainer__attachmentsForm__buttons taskModalContainer__attachmentsForm__buttons--cancel",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancelNewDocument && _ctx.cancelNewDocument(...args)))
          }, [
            _hoisted_61,
            _createTextVNode(" Cancelar ")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.addingDocument]
      ]),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("span", {
          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.openDriveStageFolder && _ctx.openDriveStageFolder(...args))),
          class: "material-symbols-outlined taskModalContainer__attachments__add"
        }, " add_to_drive "),
        _createElementVNode("span", {
          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.addDocument && _ctx.addDocument(...args))),
          class: "material-symbols-outlined taskModalContainer__attachments__add"
        }, " add "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (doc) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "taskModalContainer__attachments__links",
            key: doc.id
          }, [
            _createElementVNode("a", {
              href: doc.url,
              target: "_blank"
            }, _toDisplayString(doc.name), 9, _hoisted_63),
            _createElementVNode("button", {
              class: "taskModalContainer__attachments__buttons--delete",
              onClick: ($event: any) => (_ctx.deleteDocument(doc.id))
            }, _hoisted_66, 8, _hoisted_64)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_67,
    _createElementVNode("div", _hoisted_68, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.commentData.description) = $event)),
        name: "",
        id: "",
        cols: "30",
        rows: "3",
        placeholder: "Escribe un nuevo comentario"
      }, null, 512), [
        [_vModelText, _ctx.commentData.description]
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("button", {
          class: "taskModalContainer__createComments__buttons--add",
          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.saveComment && _ctx.saveComment(...args)))
        }, _hoisted_71),
        _createElementVNode("button", {
          class: "taskModalContainer__createComments__buttons--cancel",
          onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.deleteNewComment && _ctx.deleteNewComment(...args)))
        }, _hoisted_73)
      ])
    ]),
    _hoisted_74,
    _withDirectives(_createElementVNode("div", null, _hoisted_76, 512), [
      [_vShow, _ctx.comments.length === 0 && _ctx.documents.length === 0]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "taskModalContainer__element",
        key: comment.id
      }, [
        _createVNode(_component_CommentItem, {
          comment: comment,
          onCommentUpdated: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateComment($event))),
          onCommentDeleted: _cache[23] || (_cache[23] = ($event: any) => (_ctx.deleteComment($event)))
        }, null, 8, ["comment"])
      ]))
    }), 128))
  ]))
}